/* eslint-disable no-shadow */
import React, { useEffect, useState, useRef } from 'react'
import { message as antdMessage } from 'antd'
import { useNavigate } from 'react-router-dom'
import util from 'meinian-package/src/utils/util'
import { request } from 'meinian-package/src/utils'
import { Card } from 'component'
import MNWaterfallApi from 'component/waterfall/masonryApi'
import Button from 'meinian-package/src/baseComponent/button'
import Icon from 'meinian-package/src/component/icon'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import createInspiration from 'meinian-package/src/component/useFunModal/createInspiration'
import emitter, { EmitterEvents } from 'meinian-package/src/utils/emitter'
import globalData from 'meinian-package/src/common/globalData'
import { useRequest } from 'ahooks'
import { QUERY_TYPE } from './enum'
import LayerSelect, { RANK_DEFAULT_VALUE } from './layerSelect'
import TableViewMode from './tableViewMode'
import InspirationMode, { VIEW_MODE } from '../../components/fixedOperation/inspirationMode'
import GuideModal from '../../components/guideModal'
import styles from './index.module.less'

const NEW_RANK = { blogNum: 4, upStyleNum: 5, markPassNum: 6, unMarkNum: 7, annotationNum: 8, prepareMarkNum: 10 }

export default () => {
  const [params, setParams] = useState(RANK_DEFAULT_VALUE)
  const [viewMode, setViewMode] = useState(VIEW_MODE.MULTI)
  const [data, setData] = useState([])
  const [tableParams, setTableParams] = useState({
    start: 0,
    pageNo: 1,
  })
  const [sortParams, setSortParams] = useState({
    sortKey: null,
    sort: null,
  })
  const [totalCount, setTotalCount] = useState(0)
  const [allCount, setAllCount] = useState() // 灵感集，款式，样衣个数
  const [ready, setReady] = useState(false)
  const $masonry = useRef()
  const history = useNavigate()
  useEffect(() => {
    util.track('mn-inspiration-sidebar-page', {
      module1: '灵感集',
    })
    globalData.toGet('meinianHomeViewMode').then(res => {
      const _viewMode = Number(res) || VIEW_MODE.MULTI
      setViewMode(_viewMode)
      fetchAllCount(localStorage.getItem('meinianHomeInsQueryType') || QUERY_TYPE.ALL)
      setReady(true)
    })
  }, [])

  useEffect(() => {
    const subCreateIns = () => {
      onInit()
    }
    emitter.on(EmitterEvents.fastAccess, subCreateIns)
    return () => {
      emitter.off(EmitterEvents.fastAccess, subCreateIns)
    }
  }, [])

  const { loading, run: fetchTableData } = useRequest(async () => {
    const res = await request.post(`/zhikuan/ins/inspiration/list-inspiration?start=${tableParams.start}&pageSize=20`, { ...params, needAllNum: true })
    setData(res.resultList)
    setTotalCount(res.resultCount)
    return res
  }, {
    ready: ready && viewMode === VIEW_MODE.COLUMN,
    refreshDeps: [params, tableParams.start, viewMode]
  })

  const fetchAllCount = async (queryType) => {
    // 获取灵感集，款式，样衣的数量
    const res = await request.get('zhikuan/ins/inspiration/query-inspiration-count', { params: { queryType } })
    setAllCount(res)
  }

  const onClickViewMode = (viewMode) => {
    globalData.set('meinianHomeViewMode', viewMode)
    setViewMode(viewMode)
    if (viewMode === VIEW_MODE.COLUMN) {
      setTableParams(pre => ({ ...pre, sortKey: null, sort: null }))
    }
    onInit(viewMode)
  }

  const onExitCooperation = (inspirationId, e) => {
    e.stopPropagation()
    ModalConfirm.show({
      title: '退出协作',
      content: '是否退出协作',
      onOk: async () => {
        request.get('/zhikuan/ins/inspiration/auth/sing-out-inspiration', { params: { inspirationId } }).then(success => {
          if (success) {
            antdMessage.success('退出协作成功')
            fetchTableData()
          }
        })
      }
    })
  }

  const onInit = (_viewMode = viewMode) => {
    fetchAllCount(localStorage.getItem('meinianHomeInsQueryType') || QUERY_TYPE.ALL)
    if (_viewMode === VIEW_MODE.COLUMN) {
      fetchTableData()
    } else {
      $masonry?.current?.init()
    }
  }

  return <div className={styles.coll}>
    <InspirationMode
      viewMode={viewMode}
      style={{ right: 16, bottom: 102 }}
      onViewMode={(val) => onClickViewMode(val)}
    />
    <GuideModal
      keyValue="coll-guide"
      title="如何快速采集款式到灵感集？"
      content="美念提供采集、快速采集、插件采集和本地上传等方式 将款式采集到灵感集中。"
      onJumpUrl={() => {
        util.track('mn_newuser_click', {
          module1: '板块引导',
          module2: '灵感集引导',
        })
        window.open('/meinian/document?id=38')
      }}
    />
    <div className="meinian-coll-header">
      <div className="meinian-coll-header-left">
        <span style={{ color: 'var(--m-text-1)' }}>灵感集</span>
        <span style={{ color: 'var(--m-text-3)', marginLeft: '8px', }}>{allCount?.inspirationNums}</span>
        <span
          className="meinian-coll-header-official fill-white-bg"
          onClick={() => {
            history('/home/intellectRecommend?tabValue=4')
          }}
        >
          <Icon type="m-baogao" className="meinian-coll-header-official-icon" />
          官方灵感集已更新，请查收
        </span>
      </div>
      <div className="meinian-coll-header-right">
        <LayerSelect
          data={params}
          onChange={(val) => {
            setParams((pre) => {
              fetchAllCount({ ...pre, ...val }.queryType)
              return { ...pre, ...val }
            })
            setSortParams({
              sortKey: null,
              sort: null,
            })
            setTableParams(pre => ({ ...pre, pageNo: 1, start: 0 }))
          }}
        />
        <div style={{ marginLeft: '8px' }}>
          <Button
            type="primary"
            style={{ borderRadius: '6px' }}
            onClick={() => {
              createInspiration({
                trackSource: '灵感集新建',
                onChange: () => onInit()
              })
            }}
          >新建灵感集</Button>
        </div>
      </div>
    </div>
    <div className="meinian-home-coll">
      {viewMode === VIEW_MODE.COLUMN && ready && <TableViewMode
        data={data}
        loading={loading}
        initData={fetchTableData}
        onExitCooperation={onExitCooperation}
        totalCount={totalCount}
        pageNo={tableParams.pageNo}
        sortParams={sortParams}
        onPageChange={(val) => setTableParams(pre => ({ ...pre, ...val }))}
        onSort={(val) => {
          if (viewMode !== VIEW_MODE.COLUMN || !val.sortKey) { return }
          setTableParams(pre => ({
            ...pre,
            pageNo: 1,
            start: 0
          }))
          setSortParams({ ...val })
          if (val.sort === 'descend') {
            setParams(pre => ({ ...pre, rankStatus: -NEW_RANK[val.sortKey] }))
          } else {
            setParams(pre => ({ ...pre, rankStatus: NEW_RANK[val.sortKey] }))
          }
        }}
      />}
      {
        (viewMode === VIEW_MODE.PLAT || viewMode === VIEW_MODE.MULTI) && ready && <MNWaterfallApi
          rule={{
            widths: [2560, 1910, 1638, 1130, 910, 700, 500],
            maxColumnCount: 7
          }}
          gutter={16}
          renderItem={viewMode === VIEW_MODE.PLAT ? Card.InsColl : Card.MultiImgCard}
          url="/zhikuan/ins/inspiration/list-inspiration"
          method="post"
          cardProps={{
            trackSourceType: '灵感集侧边栏',
            fetchData: () => fetchAllCount(localStorage.getItem('meinianHomeInsQueryType') || QUERY_TYPE.ALL)
          }}
          params={params}
          ref={$masonry}
          emptyText="暂无相关灵感集"
        />
      }
    </div>
  </div>
}
